import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface DownloadVDRFileRequest {
    engagementId: number;
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export const DownloadVDRFile = createAsyncThunk(
    'dataRoom/downloadFile',
    async (
        { engagementId, fileId, fileSourceType }: DownloadVDRFileRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.get(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}?fileSourceType=${fileSourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not download file at the moment.',
                    'error'
                );
                throw new Error('Failed to download file');
            }

            return response.data as string;
        } catch (error) {
            createNotification(
                'An error occurred while downloading file.',
                'error'
            );
            throw error;
        }
    }
);

